import React, { useEffect, useState } from "react";
import Footer from "../../../components/shared/Footer";

import * as APIModels from "../../../models";
import { JobsLoggingService } from "../../../services/JobsLoggingService";

export default function JobsLoggingIndexPage() {
    const [jobs, setJobs] = useState<Array<APIModels.Job>>([]);
    const [errorMessage, setErrorMessage] = useState<string>();

    useEffect(() => {
        JobsLoggingService.getAllJobs({
            body: {
                active: true,
            } as APIModels.GetJobs,
        })
            .then((res) => {
                if (res.data && res.successful) {
                    setJobs(res.data);
                } else {
                    setErrorMessage(res.errorMessage);
                }
            })
            .catch((err) => {
                setErrorMessage(String(err));
            });
    }, []);

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title"> Analytics </h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">Jobs</a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            Logger
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Analytics
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-header">
                        <h4 className="card-title">
                            eFileMadeEasy Jobs Logger
                        </h4>
                    </div>
                    <div className="card-body">
                        {/* TODO: Move to a new component */}
                        {jobs.map((job) => {
                            return <p>{JSON.stringify(job)}</p>;
                        })}
                    </div>
                    <div className="card-footer">
                        {errorMessage && errorMessage !== "" && (
                            <p>{errorMessage}</p>
                        )}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
